import styled from "styled-components";

const BackgroundContainer = styled.div`
  width: 100%;
  position: relative;
  z-index: 2;
  background-image: url(${(props) => props.backgroundimage});
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: ${(props) => props.justifyContent ?? "center"};

  @media screen and (max-width: 900px) {
    background-size: auto;
  }
`;

const Shadow = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: ${(props) =>
    props.designId !== 1
      ? "none"
      : "radial-gradient(circle at center, rgba(0, 0, 0, 0) 20%, black 85%)"};
  z-index: 1;
  pointer-events: none;
  mix-blend-mode: darken;

  & ~ * {
    z-index: 3;
  }
`;

const BackgroundContainerComponent = ({
  children,
  backgroundimage,
  designId,
  theme,
  justifyContent,
}) => {
  return (
    <div style={{ display: "flex", width: "100%" }}>
      <BackgroundContainer
        backgroundimage={backgroundimage}
        justifyContent={justifyContent}
      >
        <Shadow designId={designId}></Shadow>
        {children}
      </BackgroundContainer>
    </div>
  );
};

export default BackgroundContainerComponent;
